import { clearAll } from '!/actions/creators';
import { connect } from 'react-redux';
import { getLocale } from '!/common/helpers';

const actions = { clearAll };

const ClearAllFilters = props => <button className="button-clear-all" onClick={props.clearAll}>{getLocale('Clear All')}</button>;

export default connect(
  null,
  actions
)(ClearAllFilters);
